import AllCoursesPage from './all-courses-page'

export default AllCoursesPage
